import { render, staticRenderFns } from "./EchartsTypeStatistics.vue?vue&type=template&id=3f622066&"
import script from "./EchartsTypeStatistics.vue?vue&type=script&lang=js&"
export * from "./EchartsTypeStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports